/**
 * Model for component BottomBar
 * @returns nothing
 */

class Model {
}

export default Model